import React from "react";
import { Component, Fragment } from "react";
import Footer from "../../component/layout/footer";
import HeaderTwo from "../../component/layout/headertwo";
import BannerTwo from '../../component/section/bannertwo';
import AboutSectionCreators from "../../component/section/about_creators";
import AboutSectionPublishers from "../../component/section/about_publishers";
import Navigate from "../../../../util/Navigate";
import { Helmet } from 'react-helmet-async';
import Glitch from 'glitch-javascript-sdk';
import { Link } from "react-router-dom";
import withRouter from "../../../../util/withRouter";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRocket, faBullhorn, faUserSecret, faShareAlt, faEnvelope, faVideo } from '@fortawesome/free-solid-svg-icons';

class HeroChatBanner extends Component {
    constructor(props) {
        super(props);
        this.state = {
            question: "",
            activeCategory: null,
            showModal: false,
        };

        // Bind methods
        this.handleCategoryClick = this.handleCategoryClick.bind(this);
        this.handlePromptClick = this.handlePromptClick.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleShowModal = this.handleShowModal.bind(this);
        this.handleCloseModal = this.handleCloseModal.bind(this);
    }

    categories = [
        {
            name: "Ads",
            icon: faBullhorn,
            prompts: [
                "What is the best way to create an ad campaign for my new game?",
                "How do I budget effectively for game ads?",
                "Which platforms are best for advertising a mobile game?",
                "Tips to measure ad performance for game campaigns?",
            ],
        },
        {
            name: "Influencers",
            icon: faUserSecret,
            prompts: [
                "How do I find the right influencers for my game?",
                "What are some best practices for influencer marketing?",
                "Tips for structuring influencer contracts?",
                "How do I track ROI from influencer campaigns?",
            ],
        },
        {
            name: "Social",
            icon: faShareAlt,
            prompts: [
                "Which social media platforms are most effective for game marketing?",
                "How often should I post about my game on social media?",
                "Tips for creating engaging social content for a new game?",
                "How to handle negative feedback or trolls on social media?",
            ],
        },
        {
            name: "Newsletter",
            icon: faEnvelope,
            prompts: [
                "How do I build an email list for my upcoming game?",
                "What should I include in a weekly game newsletter?",
                "How to avoid spam filters with game marketing emails?",
                "Best practices for segmenting email subscribers for a game launch?",
            ],
        },
    ];

    handleShowModal = () => {
        this.setState({ showModal: true });
    };

    handleCloseModal = () => {
        this.setState({ showModal: false });
    };

    handleSubmit = (e) => {
        e.preventDefault();
        const questionTrimmed = this.state.question.trim();
        if (!questionTrimmed) return;

        const encodedQuestion = encodeURIComponent(questionTrimmed);

        if (Glitch.util.Session.isLoggedIn()) {
            window.location = Navigate.titlesChatPage() + "?question=" + encodedQuestion;
        } else {
            const chatUrl = Navigate.titlesChatPage() + "?question=" + encodedQuestion;
            const registerUrl = Navigate.publishersOnboardingMultistepPage() + "?redirect=" + encodeURIComponent(chatUrl);
            window.location = registerUrl;
        }
    };

    handleCategoryClick = (category) => {
        this.setState(prevState => ({
            activeCategory: prevState.activeCategory === category ? null : category
        }));
    };

    handlePromptClick = (prompt) => {
        this.setState({ question: prompt });
    };


    render() {
        return (
            <section
                className="hero-chat-banner d-flex flex-column justify-content-center align-items-center"
                style={{
                    background: 'linear-gradient(135deg, #1a1b2f 0%, #080e37 100%)',
                    minHeight: '100vh',
                    padding: '100px 15px',
                    position: 'relative',
                    overflow: 'hidden'
                }}
            >
                <div className="container" style={{ maxWidth: "900px" }}>
                    <div className="text-center mb-5">
                        <h1
                            style={{
                                fontFamily: "'Oswald', sans-serif",
                                textTransform: "uppercase",
                                marginBottom: "1rem",
                                fontSize: "2.8rem",
                                background: 'linear-gradient(90deg, #ff0052 0%, #9400ff 100%)',
                                WebkitBackgroundClip: 'text',
                                WebkitTextFillColor: 'transparent'
                            }}
                        >
                            Marketing Built for Games
                        </h1>
                        <h2
                            className="lead"
                            style={{
                                fontSize: "1.4rem",
                                fontWeight: 400,
                                color: 'rgba(255,255,255,0.9)',
                                maxWidth: '600px',
                                margin: '0 auto'
                            }}
                        >
                            Your AI-Powered Marketing Strategist To Grow Wishlists, Sales And Players
                        </h2>
                    </div>

                    <form onSubmit={this.handleSubmit} className="position-relative mb-4">
                        <div
                            className="input-group"
                            style={{
                                borderRadius: "12px",
                                border: '1px solid rgba(255,255,255,0.1)',
                                background: 'rgba(255,255,255,0.05)',
                                backdropFilter: 'blur(10px)',
                                // Remove overflow: hidden
                            }}
                        >
                            <textarea
                                className="form-control question-input"
                                placeholder="Need help? Ask me anything about game marketing..."
                                style={{
                                    resize: "none",
                                    border: "none",
                                    height: "120px",
                                    color: "#fff",
                                    background: 'transparent',
                                    padding: '1.5rem',
                                    fontSize: '1.1rem',
                                    marginRight: '60px',
                                    '::placeholder': {
                                        color: 'rgba(255,255,255,0.7)'
                                    }
                                }}
                                value={this.state.question}
                                onChange={(e) => this.setState({ question: e.target.value })}
                            />
                            <button
                                type="submit"
                                className="btn"
                                style={{
                                    position: "absolute",
                                    bottom: "20px",
                                    right: "20px",
                                    background: "linear-gradient(90deg, #ff0052 0%, #9400ff 100%)",
                                    border: "none",
                                    width: '48px',
                                    height: '48px',
                                    borderRadius: '12px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    transition: 'transform 0.3s ease',
                                    zIndex: 100 // Add z-index
                                }}
                                aria-label="Submit question"
                            >
                                <i className="fa fa-paper-plane text-white"></i>
                            </button>
                        </div>
                    </form>

                    {/* Category Buttons */}
                    <div className="d-flex flex-wrap justify-content-center gap-3 mt-4">
                        {this.categories.map((cat) => (
                            <button
                                key={cat.name}
                                onClick={() => this.handleCategoryClick(cat.name)}
                                className="btn d-flex align-items-center gap-2"
                                style={{
                                    background: this.state.activeCategory === cat.name
                                        ? 'rgba(255,0,82,0.2)'
                                        : 'rgba(255,255,255,0.05)',
                                    border: '1px solid rgba(255,255,255,0.1)',
                                    borderRadius: '50px',
                                    padding: '12px 24px',
                                    color: '#fff',
                                    transition: 'all 0.3s ease',
                                    backdropFilter: 'blur(5px)'
                                }}
                            >
                                <FontAwesomeIcon icon={cat.icon} style={{ width: '20px' }} />
                                <span>{cat.name}</span>
                            </button>
                        ))}
                    </div>

                    {/* Sub-Prompts */}
                    {this.categories.map((cat) => (
                        this.state.activeCategory === cat.name && (
                            <div key={cat.name} className="mt-4">
                                <div className="row g-3 justify-content-center">
                                    {cat.prompts.map((prompt, idx) => (
                                        <div className="col-md-6" key={idx}>
                                            <button
                                                onClick={() => this.handlePromptClick(prompt)}
                                                style={{
                                                    width: '100%',
                                                    padding: '1rem',
                                                    background: 'rgba(255,255,255,0.03)',
                                                    border: '1px solid rgba(255,255,255,0.1)',
                                                    borderRadius: '8px',
                                                    color: '#fff',
                                                    textAlign: 'left',
                                                    transition: 'all 0.3s ease',
                                                    cursor: 'pointer'
                                                }}
                                                onMouseEnter={(e) => e.target.style.background = 'rgba(255,0,82,0.1)'}
                                                onMouseLeave={(e) => e.target.style.background = 'rgba(255,255,255,0.03)'}
                                            >
                                                {prompt}
                                            </button>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        )
                    ))}

                    <div className="text-center mt-5">
                        <button
                            className="btn btn-lg d-inline-flex align-items-center gap-2"
                            onClick={this.handleShowModal}
                            style={{
                                background: 'linear-gradient(90deg, #ff0052 0%, #9400ff 100%)',
                                color: '#fff',
                                padding: '12px 24px',
                                borderRadius: '50px',
                                border: 'none'
                            }}
                        >
                            <FontAwesomeIcon icon={faVideo} />
                            How It Works
                        </button>
                    </div>
                </div>

                {/* Modal (keep existing modal structure, add styling below) */}
                {this.state.showModal && (
                    <div
                        className="modal-backdrop show d-block"
                        style={{
                            backgroundColor: 'rgba(0,0,0,0.85)',
                            opacity: 1,
                            position: 'fixed',
                            top: 0,
                            left: 0,
                            right: 0,
                            bottom: 0,
                            zIndex: 1050,
                            backdropFilter: 'blur(8px)'
                        }}
                        onClick={this.handleCloseModal}
                    >
                        <div
                            className="modal-dialog modal-lg modal-dialog-centered"
                            style={{
                                marginTop: '5%',
                                filter: 'drop-shadow(0 0 20px rgba(0,0,0,0.3))'
                            }}
                            onClick={(e) => e.stopPropagation()}
                        >
                            <div className="modal-content border-0 overflow-hidden" style={{
                                background: 'rgba(16, 18, 47, 0.98)',
                                backdropFilter: 'blur(12px)',
                                border: '1px solid rgba(255,255,255,0.3)',
                                boxShadow: '0 8px 32px rgba(0,0,0,0.5)'
                            }}>
                                <div className="modal-header border-0 position-relative">
                                    <h5 className="modal-title text-white">How Glitch Works</h5>
                                    <button
                                        type="button"
                                        className="btn btn-danger rounded-circle p-2"
                                        onClick={this.handleCloseModal}
                                        aria-label="Close"
                                        style={{
                                            position: 'absolute',
                                            right: '20px',
                                            top: '20px',
                                            width: '40px',
                                            height: '40px',
                                            zIndex: 1060,
                                            background: '#ff0052',
                                            border: '2px solid #fff'
                                        }}
                                    >
                                        <span style={{
                                            fontSize: '1.5rem',
                                            lineHeight: 1,
                                            fontWeight: 'bold',
                                            color: '#fff'
                                        }}>×</span>
                                    </button>
                                </div>
                                <div className="modal-body p-0">
                                    <div className="ratio ratio-16x9">
                                        <iframe
                                            src="https://www.youtube.com/embed/dIYpWApbzVA?autoplay=1"
                                            title="How Glitch Works"
                                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                            allowFullScreen
                                            style={{
                                                border: 'none',
                                                background: 'transparent'
                                            }}
                                        ></iframe>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </section>
        );
    }
}

function WhatIsGlitchSection() {
    return (
        <section
            className="py-5"
            style={{
                background: 'linear-gradient(180deg, #080e37 0%, #1a1b2f 100%)',
                color: '#fff',
                position: 'relative',
                overflow: 'hidden'
            }}
        >
            <div className="container-xl py-5">
                <div className="row align-items-center g-5">
                    <div className="col-lg-6">
                        <img
                            src="/assets/images/home/all-in-one.png"
                            alt="Glitch Platform"
                            className="img-fluid rounded-3 shadow-lg"
                            style={{ border: '2px solid rgba(255,255,255,0.1)' }}
                        />
                    </div>
                    <div className="col-lg-6">
                        <h2 className="display-5 mb-4 fw-bold">
                            Your All-In-One <span style={{ color: '#ff0052' }}>Game Marketing</span> Platform
                        </h2>
                        <p className="lead mb-4" style={{ color: 'rgba(255,255,255,0.8)' }}>
                        Most games fail not because they're bad — but because no one hears about them.
Glitch empowers your game's discoverability to drive wishlist, build hype, and drive launch sales.
                        </p>
                        <p className="lead mb-4" style={{ color: 'rgba(255,255,255,0.8)' }}>

From influencer outreach to launch analytics, Glitch provides everything you need to
                            successfully market your game. Used by thousands of indies and AA studios.
                        </p>
                        <div className="d-flex flex-wrap gap-3">
                            <Link
                                to={Navigate.demoPage()}
                                className="btn btn-primary btn-lg px-4 py-3 d-flex align-items-center gap-2"
                                style={{
                                    background: 'linear-gradient(90deg, #ff0052 0%, #9400ff 100%)',
                                    border: 'none',
                                    borderRadius: '12px'
                                }}
                            >
                                <FontAwesomeIcon icon={faRocket} />
                                Schedule Demo
                            </Link>
                            <Link
                                to={Navigate.publishersOnboardingStep1Page()}
                                className="btn btn-outline-light btn-lg px-4 py-3"
                                style={{
                                    border: '2px solid rgba(255,255,255,0.2)',
                                    borderRadius: '12px'
                                }}
                            >
                                Start Free Trial
                            </Link>
                        </div>
                        <div className="mt-4 d-flex flex-wrap gap-3">
                            <div className="d-flex align-items-center gap-2">
                                <div className="text-gradient" style={{ background: 'linear-gradient(90deg, #ff0052 0%, #9400ff 100%)' }}>
                                    <i className="fas fa-check-circle fa-lg"></i>
                                </div>
                                <span>No credit card required</span>
                            </div>
                            <div className="d-flex align-items-center gap-2">
                                <i className="fas fa-clock text-muted"></i>
                                <span>Setup in 5 minutes</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

function GlitchFeaturesSection() {
    return (
        <section
            className="py-5"
            style={{
                background: '#0a0f37',
                color: '#fff',
                position: 'relative'
            }}
        >
            <div className="container-xl py-5">
                <div className="text-center mb-5">
                    <h2 className="display-5 mb-3 fw-bold">
                        Everything You Need to <span style={{ color: '#ff0052' }}>Launch Successfully</span>
                    </h2>
                    <p className="lead" style={{ color: 'rgba(255,255,255,0.8)' }}>
                        Comprehensive tools covering all aspects of game marketing
                    </p>
                </div>

                <div className="row g-4">
                    {[
                        {
                            title: "Influencer CRM",
                            image: "/assets/images/publishers/overview-crm.png",
                            description: "Need awareness? Get creators talking about your game, so you don't launch to an empty room.",
                            link: Navigate.publishersDatabasePage()
                        },
                        {
                            title: "Social Automation",
                            image: "/assets/images/publishers/overview-social.jpg",
                            description: "Too busy to post? Build consistent player hype without wasting your dev hours on marketing.",
                            link: Navigate.publishersSocialPage()
                        },
                        {
                            title: "Play Testing",
                            image: "/assets/images/publishers/overview-testers.png",
                            description: "Worried about bugs? Get real players to test your game, fix problems, and launch confidently.",
                            link: Navigate.publishersPlayTesterPage()
                        },
                        {
                            title: "Media Kits",
                            image: "/assets/images/publishers/overview-press.jpg",
                            description: "Need press coverage? Instantly give journalists everything they need to talk about your game.",
                            link: Navigate.publishersMediakitPage()
                        },
                        {
                            title: "Community Tools",
                            image: "/assets/images/publishers/overview-community.jpg",
                            description: "Want virality? Build an engaged fanbase that hypes your game for you and grows your game’s visibility.",
                            link: Navigate.publishersCommunityPage()
                        },
                        {
                            title: "Newsletters",
                            image: "/assets/images/publishers/overview-newsletter.jpg",
                            description: "Have a direct relationship with your fans for the highest conversion rates.",
                            link: Navigate.publishersNewsletterPage()
                        }
                    ].map((feature, index) => (
                        <div className="col-md-4" key={index}>
                            <div
                                className="h-100 rounded-4 p-4"
                                style={{
                                    background: 'rgba(255,255,255,0.03)',
                                    border: '1px solid rgba(255,255,255,0.1)',
                                    transition: 'all 0.3s ease'
                                }}
                            >
                                <img
                                    src={feature.image}
                                    alt={feature.title}
                                    className="img-fluid rounded-3 mb-4"
                                    style={{
                                        height: '200px',
                                        width: '100%',
                                        objectFit: 'cover'
                                    }}
                                />
                                <h3 className="h4 mb-3">{feature.title}</h3>
                                <p className="mb-4" style={{ color: 'rgba(255,255,255,0.7)' }}>
                                    {feature.description}
                                </p>
                                <Link
                                    to={feature.link}
                                    className="btn btn-sm d-flex align-items-center gap-2"
                                    style={{
                                        color: '#ff0052',
                                        textDecoration: 'none',
                                        padding: 0
                                    }}
                                >
                                    Learn More <i className="fas fa-arrow-right"></i>
                                </Link>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}

class HomeTwo extends Component {
    render() {
        return (
            <>
                <Helmet>
                    <title>Glitch - Marketing Automation for Game Developers</title>
                    <meta name="description" content="All-in-one game marketing platform with AI-powered tools for influencer marketing, social media, ads optimization, and community management." />
                </Helmet>

                <Fragment>
                    <HeaderTwo />

                    <HeroChatBanner />
                    <WhatIsGlitchSection />
                    <GlitchFeaturesSection />

                    <Footer />
                </Fragment>
            </>
        );
    }
}

export default withRouter(HomeTwo);